import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import iconUpload from '../images/icon-upload.svg';
import * as securityHelper from "../helper/SecurityHelper";
import axios from "axios";
import Snackbar from '../components/Snackbar';
import { IoIosArrowDown } from 'react-icons/io';

export default function SafetyCheck() {
  const navigate = useNavigate();
  const user: any = securityHelper.getLoginUser();
  const [self, setSelf] = useState(true);
  const [beforeFileName, setBeforeFileName] = useState('');
  const beforeFileRef = useRef() as React.MutableRefObject<any>;
  const [afterFileName, setAfterFileName] = useState('');
  const afterFileRef = useRef() as React.MutableRefObject<any>;
  const [svcCmpnyList, setSvcCmpnyList] = useState<any>([]);
  const ref_CmpnySeq = useRef<any>();
  const ref_bthNo = useRef<any>();
  const ref_cntnts = useRef<any>();
  const [bfFileSrc, setBfFileSrc] = useState<any>();
  const [afFileSrc, setAfFileSrc] = useState<any>();
  const [sctrGbNms, setSctrGbNms] = useState<any>();
  const [evntList, setEvntList] = useState<any>([]);
  const exbtPlcRef = useRef<any>();
  const [exbtPlcList, setExbtPlcList] = useState([]);
  const evntRef = useRef<any>();
  const beforeFileBtnRef = useRef<any>();
  const afterFileBtnRef = useRef<any>();
  const [snackbarTxt, setSnackbarTxt] = useState('');
  useEffect(() => { setTimeout(() => setSnackbarTxt(''), 2000) }, [snackbarTxt]);

  useEffect(() => {
    const bfFileList = beforeFileRef.current.files;
    let imgSrc;

    if (bfFileList.length > 0) {
      imgSrc = URL.createObjectURL(bfFileList[0]);
      setBfFileSrc(imgSrc);
    }
    if (afterFileRef.current) {
      const afFileList = afterFileRef.current.files;
      if (afFileList.length > 0) {
        imgSrc = URL.createObjectURL(afFileList[0]);
        setAfFileSrc(imgSrc);
      }
    }


  }, [beforeFileName, afterFileName])

  useEffect(() => {
    if (evntList.length == 1) {
      const evntSeq = evntList[0].evntSeq;
      evntRef.current.value = evntList[0].evntSeq;
      fn_retrieveHstBlngSrvCmpnyList(evntSeq);
      fn_retrievExbtPlcList(evntSeq);
    }
  }, [evntList])

  const fn_onEvntChg = (e: any) => {
    fn_retrieveHstBlngSrvCmpnyList(e.target.value);
    fn_retrievExbtPlcList(e.target.value);

    if (ref_CmpnySeq.current) {
      ref_CmpnySeq.current.value = '';
    }

    if (exbtPlcRef.current) {
      exbtPlcRef.current.value = '';
    }
  }

  const fn_retrievExbtPlcList = async (evntSeq: number) => {

    let rtrnData = await axios.post('admin/api/evnt/retrieveEvntDtlInfo', { evntSeq: evntSeq })
    rtrnData = await axios.post('admin/api/cmmn/retriveCmmnCodeList', { codeGrpId: 'A001', codes: rtrnData.data.exbtPlcs })
    setExbtPlcList(rtrnData.data);
  }

  const fn_beforeFileHandler = () => { beforeFileRef.current.click(); };
  const afterFileHandler = () => { afterFileRef.current.click(); };
  const fn_saveData = async () => {
    let cmpnySeq;

    if (user.auth == 'COM') {
      cmpnySeq = ref_CmpnySeq.current.value;
    } else if (user.auth == 'SRV') {
      cmpnySeq = user.companySeq;
    }

    const bthNo = ref_bthNo.current.value;
    const cntnts = ref_cntnts.current.value;
    const bfFileList = beforeFileRef.current.files;
    // const exbtPlcCd = exbtPlcRef.current.value;
    const evntSeq = evntRef.current.value;
    const formData = new FormData();

    if (!cmpnySeq) {
      setSnackbarTxt('업체명을 선택해 주십시오.');
      ref_CmpnySeq.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
      setTimeout(() => ref_CmpnySeq.current.style.border = 'none', 2000);
      return;
    }
    if (!evntSeq) {
      setSnackbarTxt('행사를 선택해 주십시오.');
      evntRef.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
      setTimeout(() => evntRef.current.style.border = 'none', 2000);
      return;
    }

    // if (!exbtPlcCd) {
    //   setSnackbarTxt('장소를 선택해 주십시오.');
    //   exbtPlcRef.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
    //   setTimeout(() => exbtPlcRef.current.style.border = 'none', 2000);
    //   return;
    // }
    if (!cntnts) {
      setSnackbarTxt('내용을 입력해 주십시오.');
      ref_cntnts.current.focus();
      return;
    }
    if (bfFileList.length == 0) {
      if (self) {
        setSnackbarTxt('조치 전 사진을 등록해 주세요.');
      } else {
        setSnackbarTxt('사진을 등록해 주세요.');
      }

      setTimeout(() => beforeFileBtnRef.current.click(), 1000)
      return;
    }

    if (afterFileRef.current) {
      const afFileList = afterFileRef.current.files;
      if (afFileList.length == 0) {
        setSnackbarTxt('조치 후 사진을 등록해 주세요.');
        setTimeout(() => afterFileBtnRef.current.click(), 1000)
        return;
      }
      if (afFileList.length > 0) {
        formData.append('afFiles', afFileList[0]);
      }
    }

    if (bfFileList.length > 0) {
      formData.append('bfFiles', bfFileList[0]);
    }

    let prcsStat;

    if (self) {
      prcsStat = '003';
      if (user.auth == 'SRV') {
        prcsStat = '003';
      }
    } else {
      prcsStat = '001';
    }

    const jsonObject = {
      rgstCmpnySeq: user.companySeq,
      chkTrgtCmpnySeq: cmpnySeq,
      bthNo: bthNo ? bthNo : '-',
      cntnts: cntnts,
      prcsStat: prcsStat,
      rgstrSeq: user.seq,
      chkGbCd: '001',
      trgtEvntSeq: evntSeq,
      // exbtPlcCd: exbtPlcCd,
    }

    if (!window.confirm('저장 하시겠습니까?')) {
      return;
    }

    formData.append('jsonData', JSON.stringify(jsonObject));

    const rtrnData = await axios.post('admin/api/sftyChk/saveSftyChkData', formData);

    if (rtrnData.data > 0) {
      setSnackbarTxt('저장 되었습니다.');
      setTimeout(() => window.location.reload(), 800);
    }
  };

  useEffect(() => {
    if (user.auth === 'COM') {

    } else if (user.auth === 'SRV') {
      fn_retrieveSctrGbNms();
    }

    fn_retrieveSftyChkEvntList(user.companySeq);

  }, [])

  const fn_retrieveSftyChkEvntList = async (cmpnySeq: number) => {
    const rtrnData = await axios.post('admin/api/sftyChk/retrieveSftyChkEvntList', { myCmpnySeq: cmpnySeq, auth: user.auth })

    setEvntList(rtrnData.data);
  }

  const fn_retrieveHstBlngSrvCmpnyList = async (evntSeq: any) => {
    const rtrnData = await axios.post('admin/api/sftyChk/retrieveHstBlngSrvCmpnyList', { evntSeq: evntSeq });

    setSvcCmpnyList(rtrnData.data);
  }

  const fn_retrieveSctrGbNms = async () => {
    const rtrnData = await axios.post('admin/api/sftyChk/retrieveSctrGbNms', { cmpnySeq: user.companySeq });

    setSctrGbNms(rtrnData.data);
  }

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      <NavbarText backEvent={() => navigate(-1)}>안전 점검</NavbarText>
      {user.auth === 'COM' &&
        <div className='h-76 md:h-[190px] flex items-center justify-center -translate-y-10 md:-translate-y-[25px]'>
          <Btn self={self} setSelf={setSelf} />
        </div>}
      <div className={user.auth === 'COM' ? `bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-128px)] md:h-[calc(100%-320px)]`
        : `bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-52px)] md:h-[calc(100%-130px)]`}>
        <div className='w-[265px] sm:w-[318px] md:w-[750px] mb-20 md:mb-[50px]'>
          <p className='mt-35 ml-8 text-15 leading-18 md:mt-[87px] md:ml-[20px] md:text-37 md:leading-[45px] font-preBold'>상세내용</p>
          <table className='table-fixed w-full overflow-auto mt-19 md:mt-[47px]'>
            <tbody>
              <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                <td colSpan={1} className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>{user.auth === 'COM' ? '주최사' : '업체명'}</td>
                <td colSpan={4} className='align-middle pl-8 sm:pl-14 md:pl-[35px] font-preLight w-230 sm:w-260 text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{user.companyName}</td>
              </tr>
              {user.auth === 'SRV' &&
                <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                  <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>업종</td>
                  <td colSpan={2} className='align-middle pl-8 sm:pl-14 md:pl-[35px] font-preLight w-230 sm:w-260 text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{sctrGbNms}</td>
                  <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>대표자</td>
                  <td className='align-middle pl-8 sm:pl-14 md:pl-[35px] font-preLight w-230 sm:w-260 text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{user.representative}</td>
                </tr>}
            </tbody>
          </table>
          <table className='table-fixed w-full overflow-auto mt-20 md:mt-[50px]'>
            <tbody>
              <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>행사</td>
                <td colSpan={3} className='align-middle pl-7 pr-12 md:ml-[17px] md:pr-[30px] font-preLight text-14 md:text-35 leading-16 md:leading-[40px]'>
                  <div className='md:flex md:flex-row md:items-center md:justify-stretch md:pl-[10px]'>
                    <select ref={evntRef}
                      onChange={fn_onEvntChg}
                      className='w-full h-full outline-none px-3 py-3 md:px-[7px] md:py-[7px] rounded-[5px] md:rounded-[12px] md:appearance-none'>
                      <option value={''}>선택</option>
                      {
                        evntList.map((evnt: any) => (
                          <option key={evnt.evntSeq} value={evnt.evntSeq}>{evnt.evntNm}</option>
                        ))
                      }
                    </select>
                    <IoIosArrowDown className='hidden md:block md:w-[40px] md:h-[90px]' />
                  </div>
                </td>
              </tr>
              {user.auth === 'COM' &&
                <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                  <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>업체명</td>
                  <td colSpan={3} className='align-middle pl-7 pr-12 md:ml-[17px] md:pr-[30px] font-preLight text-14 md:text-35 leading-16 md:leading-[40px]'>
                    <div className='md:flex md:flex-row md:items-center md:justify-stretch md:w-[100%]'>
                      <select
                        ref={ref_CmpnySeq}
                        className='w-full h-full outline-none px-3 py-3 md:px-[7px] md:py-[7px] rounded-[5px] md:rounded-[12px] md:appearance-none'>
                        <option value={''}>행사명을 선택해 주세요.</option>
                        {svcCmpnyList.map((svcCmpny: any) => (
                          <option key={svcCmpny.cmpnySeq} value={svcCmpny.cmpnySeq}>{svcCmpny.cmpnyNm}</option>
                        ))}
                      </select>
                      <IoIosArrowDown className='hidden md:block md:w-[40px] md:h-[90px]' />
                    </div>
                  </td>
                </tr>}
              <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
                {/*<td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>장소</td>*/}
                {/*<td className='align-middle pl-7 pr-12 md:pl-[17px] md:pr-[30px] font-preLight text-14 md:text-35 leading-16 md:leading-[40px]'>*/}
                {/*  <div className='md:flex md:flex-row md:items-center md:justify-stretch md:w-[100%]'>*/}
                {/*    <select ref={exbtPlcRef} className='w-full h-full outline-none px-3 py-3 md:px-[7px] md:py-[7px] rounded-[5px] md:rounded-[12px] md:appearance-none'>*/}
                {/*      <option value={''}>선택</option>*/}
                {/*      {*/}
                {/*        exbtPlcList.map((exbtPlc: any) => (*/}
                {/*          <option key={exbtPlc.code} value={exbtPlc.code}>{exbtPlc.codeNm}</option>*/}
                {/*        ))*/}
                {/*      }*/}
                {/*    </select>*/}
                {/*    <IoIosArrowDown className='hidden md:block md:w-[40px] md:h-[90px]' />*/}
                {/*  </div>*/}
                {/*</td>*/}
                <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-37'>부스번호</td>
                <td className='align-middle pl-8 pr-12 md:pl-[20px] md:pr-[30px] font-preLight text-14 md:text-35 leading-16 md:leading-[40px]'>
                  <input type='text'
                    ref={ref_bthNo}
                    className='w-full text-10 sm:text-12 md:text-30 outline-none placeholder:text-10 sm:placeholder:text-12 md:placeholder:text-30 placeholder:text-[#9C9C9B] placeholder:leading-16 md:placeholder:leading-[40px] placeholder:font-preLight' placeholder='입력해주세요.' />
                </td>
              </tr>
              <tr className='h-107 text-14 leading-16 md:h-[267px] md:text-35 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
                <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>내용</td>
                <td colSpan={3} className='align-top pt-12 pl-14 pr-12 md:pt-[30px] md:pl-[35px] md:pr-[30px] font-preLight w-230 sm:w-260 text-14 md:text-35 leading-16 md:leading-[40px]'>
                  <textarea
                    ref={ref_cntnts}
                    className='w-full h-107 md:h-[267px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px] scrollbar-hide outline-none placeholder:text-12 sm:placeholder:text-14 md:placeholder:text-35 placeholder:text-[#9C9C9B] placeholder:leading-16 md:placeholder:leading-[40px] placeholder:font-preLight' placeholder='내용을 입력해주세요.' />
                </td>
              </tr>

              <tr className='h-107 text-14 leading-16 md:h-[267px] md:text-35 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
                <td colSpan={1} className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>{self ? '조치 전' : '사진'}</td>
                <td colSpan={3} className='align-middle font-preLight w-230 md:w-260 text-14 md:text-35 leading-16 md:leading-[40px]'>
                  {!beforeFileName
                    ? <button ref={beforeFileBtnRef} onClick={fn_beforeFileHandler} className='mx-auto flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                      <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                      <p>파일 올리기</p>
                    </button>
                    : <img onClick={fn_beforeFileHandler} src={bfFileSrc} alt='beforeImage' className='object-cover px-3 py-3 md:px-[7px] md:py-[7px]' />}
                  <input hidden onChange={(e) => setBeforeFileName(e.target.value.substring(12))} type='file' ref={beforeFileRef} />
                </td>
              </tr>
              {self && <tr className='h-107 text-14 leading-16 md:h-[267px] md:text-35 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
                <td colSpan={1} className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 leading-37'>조치 후</td>
                <td colSpan={3} className='align-middle font-preLight w-230 sm:w-260  text-14 md:text-35 leading-16 md:leading-[40px]'>
                  {!afterFileName
                    ? <button ref={afterFileBtnRef} onClick={afterFileHandler} className='mx-auto flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                      <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                      <p>파일 올리기</p>
                    </button>
                    : <img onClick={afterFileHandler} src={afFileSrc} alt='afterImage' className='object-cover px-3 py-3 md:px-[7px] md:py-[7px]' />}
                  <input hidden onChange={(e) => setAfterFileName(e.target.value.substring(12))} type='file' ref={afterFileRef} />
                </td>
              </tr>}
            </tbody>
          </table>
          {self &&
            <button onClick={fn_saveData} className='font-preLight text-15 md:text-37 text-white w-full h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-25 md:mt-[62px]'>안전 조치 등록</button>}
        </div>
        {!self &&
          <button onClick={fn_saveData}
            className='w-[265px] sm:w-[318px] md:w-[750px] mb-20 md:mb-[50px] font-preLight text-15 md:text-37 text-white h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto py-10 md:py-[25px]'>안전 조치 요청</button>}
      </div>
    </div>
  );
};

const Btn = ({ self, setSelf }: any) => {
  return (
    <div className='flex'>
      <button onClick={() => setSelf(true)}
        className={self ? `border rounded-l-[5px] md:rounded-l-[12px] border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
          : `border border-r-0 rounded-l-[5px] md:rounded-l-[12px] border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`}>자가 조치</button>
      <button onClick={() => setSelf(false)}
        className={self ? `border border-l-0 rounded-r-[5px] md:rounded-l-[12px] border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
          : `border rounded-r-[5px] md:rounded-l-[12px] border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`}>조치 요청</button>
    </div>
  );
};